export var ButtonEvents;
(function (ButtonEvents) {
  ButtonEvents["Redirection"] = "redirection";
  ButtonEvents["PopupWebform"] = "popupWebform";
  ButtonEvents["SubmitWebform"] = "submitWebform";
  ButtonEvents["Next"] = "next";
  ButtonEvents["GetIntent"] = "getIntent";
  ButtonEvents["ShowAgentQueue"] = "showAgentQueue";
  ButtonEvents["ToLiveAgent"] = "toLiveAgent";
  ButtonEvents["ShowArticle"] = "showArticle";
  ButtonEvents["ShowConfirm"] = "showConfirm";
  ButtonEvents["ShowOrder"] = "showOrder";
  ButtonEvents["ShowTransaction"] = "showTransaction";
  ButtonEvents["ClickShortcut"] = "clickShortcut";
  ButtonEvents["CancelOrder"] = "cancelOrder";
  ButtonEvents["ClickCategory"] = "clickCategory";
  ButtonEvents["ExtendShopeeGuarantee"] = "extendShopeeGuarantee";
  ButtonEvents["Login"] = "login";
  ButtonEvents["ClickIntent"] = "clickIntent";
  ButtonEvents["SubmitFeedback"] = "submitFeedback";
  ButtonEvents["PopArticle"] = "popArticle";
  ButtonEvents["MoreOrder"] = "moreOrder";
  ButtonEvents["ClickSubIntent"] = "clickSubIntent";
  ButtonEvents["ClickQAButton"] = "clickQAButton";
  ButtonEvents["ClickTaskBot"] = "clickTaskBot";
  ButtonEvents["ClickArticleRedirectionButton"] = "clickArticleRedirectionButton";
  ButtonEvents["OpenExternalLink"] = "openExternalLink";
  ButtonEvents["InternetCall"] = "internetCall";
  ButtonEvents["NoQueueInternetCall"] = "noQueueInternetCall";
  ButtonEvents["popupSelectProduct"] = "popupSelectProduct";
  ButtonEvents["popupSelectOrder"] = "popupSelectOrder";
  ButtonEvents["Unsupport"] = "unsupport";
})(ButtonEvents || (ButtonEvents = {}));
export var UIEvents;
(function (UIEvents) {
  UIEvents["InputChange"] = "inputChange";
  UIEvents["InputSubmit"] = "inputSubmit";
  UIEvents["FeedbackClick"] = "feedbackClick";
  UIEvents["PreviewImage"] = "previewImage";
})(UIEvents || (UIEvents = {}));